<script>
    import {createEventDispatcher} from "svelte";
    import {I_PEOPLE_TAG, people_tags, people_tags_search_list} from "../stores/people_tags";
    import {objectifyArray} from "../../../../../lib/datatypes";
    import {inArray} from "../../../../../lib/utils";
    import Tag from "./Tag.svelte";

    const dispatch = createEventDispatcher();

    export let tag_id_list = '';

    export let current_search_str = '';

    // NB annoyingly `split` returns an array wrapped empty string if the tag_id_list === '' (rather than an
    // empty array, which would be ideal).. so, we have to filter for that case first, before then transforming
    // things if there are real ids in the string
    $: tag_ids_arr = tag_id_list.split(',').filter(id => {
        if(id === '') return false;
        return $people_tags.lookup[id.trim()][I_PEOPLE_TAG.DELETED] === false;
    }).map(id => {
        return id.trim();
    });

    $: searched_tags = current_search_str === '' ? $people_tags.list : $people_tags_search_list.filter(entry => {
        return entry[0].includes(current_search_str.toLowerCase());
    }).map(entry => {
        return $people_tags.lookup[entry[1]];
    });

    const onItemClicked = id => {
        dispatch('tagClicked', {id:id});
    }
</script>



<div>
    <div class="relative mt-1 rounded-md shadow-sm">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <svg class="h-5 w-5 text-gray-400" x-description="Heroicon name: mini/magnifying-glass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd"></path>
            </svg>
        </div>
        <input bind:value={current_search_str} type="search" name="search" id="search" class="block w-full rounded-md border-gray-300 pl-10 focus:border-pink-500 focus:ring-pink-500 sm:text-sm" placeholder="Search">
    </div>
</div>

<ol class="xabsolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base border border-gray-300 focus:outline-none sm:text-sm">
    {#each searched_tags.map(tag => objectifyArray(I_PEOPLE_TAG, tag)) as tag (tag.id)}
        <li on:click={() => onItemClicked(tag.id)}
            class="relative cursor-default select-none py-2 pl-8 pr-4 text-gray-900">
            {#if inArray(tag_ids_arr, tag.id)}
                <span class="block truncate text-sm"><Tag display_tag={tag}></Tag>= {tag.description}</span>
                <span class="absolute inset-y-0 left-0 flex items-center pl-1.5 text-indigo-600">
                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                    </svg>
                </span>
            {:else}
                <span class="block truncate text-sm"><Tag display_tag={tag}></Tag>= {tag.description}</span>
            {/if}
        </li>
    {/each}
</ol>

<!--
bg-rose-100 bg-rose-200 bg-rose-500 text-rose-400 text-rose-500 text-rose-700
bg-indigo-100 bg-indigo-200 bg-indigo-500 text-indigo-400 text-indigo-500 text-indigo-700
-->

<style></style>